import { Fragment, useState } from "react";
import Card from "./components/card/Card";
import {
  Container,
  Description,
  SubTitle,
  Text,
  Title,
  Wrapper,
} from "./styled";

export default function Faq({ data }) {
  const [openedId, setOpenedId] = useState(null);

  const handleCardClick = (cardId) => {
    if (openedId !== cardId) {
      setOpenedId(cardId);
    } else {
      setOpenedId(null);
    }
  };

  if (!data) {
    return;
  }

  return (
    <Container>
      <Wrapper>
        <Title>{data.title}</Title>
        <Description>{data.subtitle}</Description>
        {data.sections.map((section, idx) => (
          <Fragment key={idx}>
            <SubTitle>{section.title}</SubTitle>
            {section.questions.map((questionData, idx2) => {
              const id = `${idx}-${idx2}`;
              return (
                <Card
                  title={questionData.question}
                  key={id}
                  isOpened={openedId === id}
                  onClick={() => handleCardClick(id)}
                >
                  <Text>{questionData.answer}</Text>
                </Card>
              );
            })}
          </Fragment>
        ))}
      </Wrapper>
    </Container>
  );
}
